import { useEffect } from 'react';
import type { Stage } from '@eventbrite/webapp-constants';

// Values from https://github.com/eventbrite/eb-ui/blob/main/packages/infra/real-user-monitoring/src/utils/rum.ts#L75
const DATADOG_CONFIG = {
  APPLICATION_ID: '1429889f-7c31-4b1d-a280-e94ec0704262',
  CLIENT_TOKEN: 'pubf43fcf8de511ce458f04cbdf8dc2deb6',
  SITE: 'datadoghq.com' as const,
  SERVICE: 'rum-web--listings-webapp',
  // The build id (`<commit sha>-<stage>`) is inlined into the client bundle at
  // build time via next.config's `env` (fed by LISTINGS_WEBAPP_BUILD_ID). It
  // must stay identical to the `--release-version` used when uploading source
  // maps (see app `datadog:sourcemaps` script) so Datadog can symbolicate RUM
  // stack traces. Falls back to 'dev' for local builds where no build id is set.
  VERSION: process.env.NEXT_PUBLIC_BUILD_ID || 'dev',
  // decrease it to 0.15 when more traffic is handled by listings-webapp
  SESSION_SAMPLE_RATE: 1,
};

let initialized = false;

export let isDatadogInitialized = false;

const initializeDatadogRum = async (stage: Stage) => {
  if (initialized) return;

  const { datadogRum } = await import('@datadog/browser-rum-slim');
  datadogRum.init({
    applicationId: DATADOG_CONFIG.APPLICATION_ID,
    clientToken: DATADOG_CONFIG.CLIENT_TOKEN,
    site: DATADOG_CONFIG.SITE,
    service: DATADOG_CONFIG.SERVICE,
    env: stage,
    version: DATADOG_CONFIG.VERSION,
    sessionSampleRate: DATADOG_CONFIG.SESSION_SAMPLE_RATE,
    trackUserInteractions: true,
  });
  initialized = true;
  isDatadogInitialized = true;
};

export const DatadogInit = ({ stage }: { stage: Stage }) => {
  useEffect(() => {
    const initDatadogRum = async () => {
      await initializeDatadogRum(stage);
    };
    initDatadogRum().catch((error) => {
      console.error('Error initializing Datadog:', error);
    });
  }, []);

  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
};
